var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/**
 * Function to define the config for the app
 * It will be used by vite.config.ts and other files in other to configure the app
 * @param {AppConfig} loadedConfig
 */
export var defineConfig = function (loadedConfig) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    var reactStrictMode = loadedConfig.reactStrictMode, server = loadedConfig.server, vite = loadedConfig.vite, experimental = loadedConfig.experimental;
    // Define default values for vite config coming from loadedConfig.vite
    var defaultViteConfig = {
        plugins: (vite === null || vite === void 0 ? void 0 : vite.plugins) || [],
        optimizeDeps: {
            exclude: ((_a = vite === null || vite === void 0 ? void 0 : vite.optimizeDeps) === null || _a === void 0 ? void 0 : _a.exclude) || [],
            include: ((_b = vite === null || vite === void 0 ? void 0 : vite.optimizeDeps) === null || _b === void 0 ? void 0 : _b.include) || [],
        },
        css: {
            postcss: ((_c = vite === null || vite === void 0 ? void 0 : vite.css) === null || _c === void 0 ? void 0 : _c.postcss) || undefined,
        },
        build: {
            external: ((_d = vite === null || vite === void 0 ? void 0 : vite.build) === null || _d === void 0 ? void 0 : _d.external) || [],
        },
        resolve: {
            symbole: ((_e = vite === null || vite === void 0 ? void 0 : vite.resolve) === null || _e === void 0 ? void 0 : _e.symbole) || '@',
            alias: ((_f = vite === null || vite === void 0 ? void 0 : vite.resolve) === null || _f === void 0 ? void 0 : _f.alias) || [],
        },
    };
    // Define default values for server config coming from loadedConfig.server
    var defaultServerConfig = {
        development: {
            port: ((_g = server === null || server === void 0 ? void 0 : server.development) === null || _g === void 0 ? void 0 : _g.port) || undefined,
            open: ((_h = server === null || server === void 0 ? void 0 : server.development) === null || _h === void 0 ? void 0 : _h.open) || false,
        },
        production: {
            hosting: ((_j = server === null || server === void 0 ? void 0 : server.production) === null || _j === void 0 ? void 0 : _j.hosting) || "custom",
        },
    };
    // Define default values for experimentals features coming from loadedConfig.experimentals
    var defaultExperimentalFeaturesConfig = {
        stream: (experimental === null || experimental === void 0 ? void 0 : experimental.stream) || false
    };
    try {
        var config = {
            reactStrictMode: reactStrictMode === undefined ? true : reactStrictMode,
            server: defaultServerConfig,
            vite: {
                plugins: defaultViteConfig.plugins,
                optimizeDeps: {
                    exclude: __spreadArray([
                        "node:http",
                        "node-fetch"
                    ], defaultViteConfig.optimizeDeps.exclude, true),
                    include: __spreadArray([
                        "react-fast-compare",
                        "invariant",
                        "shallowequal",
                        "react-dom/client",
                        "react-dom",
                        "react",
                        "react-router-dom",
                        "react-helmet-async"
                    ], defaultViteConfig.optimizeDeps.include, true),
                },
                css: {
                    postcss: defaultViteConfig.css.postcss,
                },
                build: {
                    external: defaultViteConfig.build.external,
                },
                resolve: {
                    // concat two arrays
                    alias: __spreadArray([
                        {
                            find: defaultViteConfig.resolve.symbole,
                            replacement: "./src",
                        },
                        {
                            find: "path",
                            replacement: "node_modules/path-browserify",
                        }
                    ], defaultViteConfig.resolve.alias, true),
                },
                appType: "custom",
            },
            experimental: defaultExperimentalFeaturesConfig,
            // More config options...
        };
        return config;
    }
    catch (error) {
        console.error(error);
        return {
            reactStrictMode: true,
            vite: {
                optimizeDeps: {
                    exclude: ["node:http", "node-fetch"],
                    include: [
                        "react-fast-compare",
                        "invariant",
                        "shallowequal",
                        "react-dom/client",
                        "react-dom",
                        "react",
                        "react-router-dom",
                        "react-helmet-async",
                    ],
                },
                appType: "custom",
                resolve: {
                    alias: [
                        {
                            find: "@",
                            replacement: "./src",
                        },
                        {
                            find: "path",
                            replacement: "node_modules/path-browserify",
                        },
                    ],
                },
            },
            experimental: {
                stream: false
            },
        };
    }
};
/**
 * Function to adapt the path for dev and prod
 * @param {string | Array<string>} paths
 */
export var adaptPath = function (paths) {
    // Check if we are in dev mode or prod
    var isProduction = process.env.NODE_ENV === "production";
    var prefix = isProduction ? "./../../" : "";
    // Chech if the path is an array
    var isArray = Array.isArray(paths);
    // If the path is an array
    if (isArray) {
        return paths.map(function (path) { return "".concat(process.cwd(), "/").concat(prefix).concat(path); });
    }
    // If the path is a string
    return "".concat(process.cwd(), "/").concat(prefix).concat(paths);
};
/**
 * Adapts the provided file path to a valid URL format based on the operating system.
 *
 * @param path - The file path to be adapted.
 * @returns The adapted file path in a valid URL format.
 */
export var resolvePath = function (path) {
    // Check the OS
    var isWindows = process.platform === "win32";
    // Adapt the path
    if (isWindows) {
        return "file:///".concat(path);
    }
    return path;
};
